import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/rafaelosorio/Documents/GitHub/cp4i-demohub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>Automate customer interactions using APIs and Integration Demo</span>;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`There are 3 options to deliver this demo. Select the options below:`}</p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Click-Through Demo (Screenshot Demo)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">100 Live Demo (Shared Environment)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">300 Live Demo (Own Environment)</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Click-Through Demo (Screenshot Demo)`}</h2>
    <p>{`Click-Through Demo is a static demo based on screenshot pictures. It is a good demo for a “First-Demo” scenario, just to introduce and give a solid view about the benefits of our solution. The Demo Script is almost the same of the live demo. You are able to deliver this demo with or without an internet connection. Open the assets below to know how to deliver the Click-Through Demo.`}</p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Online Demo Link" href="https://ibm.invisionapp.com/share/2SO0YKSA74R" author="Access the Online Demo" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "473px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVElEQVQ4y42TTUhUURTH333v3fmesRnHcZSZnLFBzI+yMc0ca8ZMF40I9oGBUVPhTlu1S4I0XASRlRSU7hSxRYgGtUmCgqhFy9wGBW5yVVHR4tdz3tQ4OYQPDve+c8/5/8+noigK25EyT4QSR/kmncieHluQQEl0s21xAKGo2bOiMozHoRFw1VAX6kJT9b82Nt3NcN9DTvVlCJT7CwF9/jIa4y243J4C4HDqDgcys1THqtH+6IVJZtHcJFqP0toWx+v1FQK2p7pJ9qTRLbrhaCceuojF0Jd2TXP4JjRfe03L4AjhUMiwV/OkQmCR+taUA8FKdGnP3qVq53zTSzJ1S3Sl39B76zun59domVul/fYM0V0RFBnEVXMBazBlgMpCQFU1GYXBpogNpZOxM2+ZHf3M5LmvXBn6wcjMGgNL79m/8JTqhjqEczfO2CDS24DQHf9pijC7l6y9xOLdj6y+gndzvxi6us7J55/onF8mWt+YD+Bff4fdxdjYOIuLj2mKx03DXCcdSozh/mleTMGxzvv4hidoXnhGzd49OXINKSXeHSVoWq6OXk+A6alHbHw/v8GRRDr7oGv5ujRWnCDmazLHKNFNRaQq96ZhtTpIJNPYrVphyqmDvfT3ZLBJjzm0BrtQpSGmYVX5Pi73LVPrb8v+a5ole6Z7B5h68AF/tCcXteEs1HwtVH8EvbSqYBts0s3Z5CSjx1eoLG3IAZopjl+fYP0L3Lj3xFiGTRGq6gawBd/OepzBcNHt8bnCWKVzi76jo41U6lDxLmvGCAmxvf0uJr8Bo31qf27UgHwAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lab",
              "title": "lab",
              "src": "/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/739ea/lab.png",
              "srcSet": ["/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/7fc1e/lab.png 288w", "/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/739ea/lab.png 473w"],
              "sizes": "(max-width: 473px) 100vw, 473px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Offline Demo File" href="https://ibm.box.com/s/6cqx27ygqhembmw1wj3msw42ubmm3okc" author="Download the Offline Demo File" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "473px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVElEQVQ4y42TTUhUURTH333v3fmesRnHcZSZnLFBzI+yMc0ca8ZMF40I9oGBUVPhTlu1S4I0XASRlRSU7hSxRYgGtUmCgqhFy9wGBW5yVVHR4tdz3tQ4OYQPDve+c8/5/8+noigK25EyT4QSR/kmncieHluQQEl0s21xAKGo2bOiMozHoRFw1VAX6kJT9b82Nt3NcN9DTvVlCJT7CwF9/jIa4y243J4C4HDqDgcys1THqtH+6IVJZtHcJFqP0toWx+v1FQK2p7pJ9qTRLbrhaCceuojF0Jd2TXP4JjRfe03L4AjhUMiwV/OkQmCR+taUA8FKdGnP3qVq53zTSzJ1S3Sl39B76zun59domVul/fYM0V0RFBnEVXMBazBlgMpCQFU1GYXBpogNpZOxM2+ZHf3M5LmvXBn6wcjMGgNL79m/8JTqhjqEczfO2CDS24DQHf9pijC7l6y9xOLdj6y+gndzvxi6us7J55/onF8mWt+YD+Bff4fdxdjYOIuLj2mKx03DXCcdSozh/mleTMGxzvv4hidoXnhGzd49OXINKSXeHSVoWq6OXk+A6alHbHw/v8GRRDr7oGv5ujRWnCDmazLHKNFNRaQq96ZhtTpIJNPYrVphyqmDvfT3ZLBJjzm0BrtQpSGmYVX5Pi73LVPrb8v+a5ole6Z7B5h68AF/tCcXteEs1HwtVH8EvbSqYBts0s3Z5CSjx1eoLG3IAZopjl+fYP0L3Lj3xFiGTRGq6gawBd/OepzBcNHt8bnCWKVzi76jo41U6lDxLmvGCAmxvf0uJr8Bo31qf27UgHwAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lab",
              "title": "lab",
              "src": "/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/739ea/lab.png",
              "srcSet": ["/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/7fc1e/lab.png 288w", "/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/739ea/lab.png 473w"],
              "sizes": "(max-width: 473px) 100vw, 473px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Click-Through Demo Script" href="/salesdemos/carrepair-new/click-demoscript" author="How to deliver the Demo" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "473px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZUlEQVQoz2NI3n8PE6Xsv5d06FHsvvs+E9bFHXiYePBRyoH7mMoYUPj77qYA0cH7ifvuxk5YmTNxWWLNxOyJy2O7F8fvvJFy8EHyvjs4NIO0PYjd/zhh3/2AJYcnzVlx/9qVu7duf3jxfMHi1d6zd6cdBtu/7y6G5n13Uw8/ilp7NimrML5vofOkzRPmrTp1/OSVazfevX+3aNVmx7YlEcuOxGy6mIzkfoTmtKNPXNqXtZdnVq3Zat+7obF7xvH9h/btOXjm2Mmu/lkuXStDF+wLmLUjcvUpuH6Y5gP3o1ed9Ji61XDFpYhNl4rnrPJpnOPdvtS3ZT4QebcuDJy9M2junqC5u4H6o9adAfv/LkPy3jsgr269EjR7p/+cXRLlC+IW7JrTXtpRmFLX0Rm6YG/gwgPBC/YBtQXNA2kOmrsLSCZsv5Zy4B5DyuHHQGtDgBLz9gTM2KYrr29XPLG9KHmnC3tdZbHfwiPBc3YGz98LRIHTtwbN2QVkAJVFrDyecvgRQ8zK49HLjzhEFwfP3enetTItLDhjzqrizNRGS4W6qmLvBYftQ3M8a6YHTN9qH1noN2FN4Mxt9jGlAVM2xm2+yGDtFmPrn2bhFGnpFG7iHBPsG+zuEeZlbOVnaBpnaWoRUmBu5W9m5W/pFmPpEm3hHAlElq7RFi7Rdv5pDMZ6TkCkr2yur2hqoGSmp2yhp2Smr2ppqG5loGJpoGppoGZlpG1vrOdsoGKurwRSY6BioQ9Uo2TGYKBqoQ9SYW2gbg0kDdWswAikDcgA6gTpV7UEq7ECq7GCIKAsg4mmLRAZ40Z4ZAFW8XWeQcvFnAAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lecture",
              "title": "lecture",
              "src": "/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/739ea/lecture.png",
              "srcSet": ["/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/7fc1e/lecture.png 288w", "/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/739ea/lecture.png 473w"],
              "sizes": "(max-width: 473px) 100vw, 473px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <hr></hr>
    <h2>{`100 Live Demo (Shared Environment)`}</h2>
    <p>{`Are you looking for quick live demos using a shared environment? You are on the right place. Open the assets below to know how to deliver the 100 Demo.`}</p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Requesting Access to the Shared Demo Environment" href="https://ibm-garage-tsa.github.io/cp4i-demohub/cp4i-on-roks/outcomes" author="Steps to access your CP4I Demo Environment" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "473px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVElEQVQ4y42TTUhUURTH333v3fmesRnHcZSZnLFBzI+yMc0ca8ZMF40I9oGBUVPhTlu1S4I0XASRlRSU7hSxRYgGtUmCgqhFy9wGBW5yVVHR4tdz3tQ4OYQPDve+c8/5/8+noigK25EyT4QSR/kmncieHluQQEl0s21xAKGo2bOiMozHoRFw1VAX6kJT9b82Nt3NcN9DTvVlCJT7CwF9/jIa4y243J4C4HDqDgcys1THqtH+6IVJZtHcJFqP0toWx+v1FQK2p7pJ9qTRLbrhaCceuojF0Jd2TXP4JjRfe03L4AjhUMiwV/OkQmCR+taUA8FKdGnP3qVq53zTSzJ1S3Sl39B76zun59domVul/fYM0V0RFBnEVXMBazBlgMpCQFU1GYXBpogNpZOxM2+ZHf3M5LmvXBn6wcjMGgNL79m/8JTqhjqEczfO2CDS24DQHf9pijC7l6y9xOLdj6y+gndzvxi6us7J55/onF8mWt+YD+Bff4fdxdjYOIuLj2mKx03DXCcdSozh/mleTMGxzvv4hidoXnhGzd49OXINKSXeHSVoWq6OXk+A6alHbHw/v8GRRDr7oGv5ujRWnCDmazLHKNFNRaQq96ZhtTpIJNPYrVphyqmDvfT3ZLBJjzm0BrtQpSGmYVX5Pi73LVPrb8v+a5ole6Z7B5h68AF/tCcXteEs1HwtVH8EvbSqYBts0s3Z5CSjx1eoLG3IAZopjl+fYP0L3Lj3xFiGTRGq6gawBd/OepzBcNHt8bnCWKVzi76jo41U6lDxLmvGCAmxvf0uJr8Bo31qf27UgHwAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lab",
              "title": "lab",
              "src": "/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/739ea/lab.png",
              "srcSet": ["/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/7fc1e/lab.png 288w", "/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/739ea/lab.png 473w"],
              "sizes": "(max-width: 473px) 100vw, 473px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="100 Demo Script" href="/salesdemos/carrepair-new/100-demoscript" author="How to deliver the Demo" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "473px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZUlEQVQoz2NI3n8PE6Xsv5d06FHsvvs+E9bFHXiYePBRyoH7mMoYUPj77qYA0cH7ifvuxk5YmTNxWWLNxOyJy2O7F8fvvJFy8EHyvjs4NIO0PYjd/zhh3/2AJYcnzVlx/9qVu7duf3jxfMHi1d6zd6cdBtu/7y6G5n13Uw8/ilp7NimrML5vofOkzRPmrTp1/OSVazfevX+3aNVmx7YlEcuOxGy6mIzkfoTmtKNPXNqXtZdnVq3Zat+7obF7xvH9h/btOXjm2Mmu/lkuXStDF+wLmLUjcvUpuH6Y5gP3o1ed9Ji61XDFpYhNl4rnrPJpnOPdvtS3ZT4QebcuDJy9M2junqC5u4H6o9adAfv/LkPy3jsgr269EjR7p/+cXRLlC+IW7JrTXtpRmFLX0Rm6YG/gwgPBC/YBtQXNA2kOmrsLSCZsv5Zy4B5DyuHHQGtDgBLz9gTM2KYrr29XPLG9KHmnC3tdZbHfwiPBc3YGz98LRIHTtwbN2QVkAJVFrDyecvgRQ8zK49HLjzhEFwfP3enetTItLDhjzqrizNRGS4W6qmLvBYftQ3M8a6YHTN9qH1noN2FN4Mxt9jGlAVM2xm2+yGDtFmPrn2bhFGnpFG7iHBPsG+zuEeZlbOVnaBpnaWoRUmBu5W9m5W/pFmPpEm3hHAlElq7RFi7Rdv5pDMZ6TkCkr2yur2hqoGSmp2yhp2Smr2ppqG5loGJpoGppoGZlpG1vrOdsoGKurwRSY6BioQ9Uo2TGYKBqoQ9SYW2gbg0kDdWswAikDcgA6gTpV7UEq7ECq7GCIKAsg4mmLRAZ40Z4ZAFW8XWeQcvFnAAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lecture",
              "title": "lecture",
              "src": "/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/739ea/lecture.png",
              "srcSet": ["/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/7fc1e/lecture.png 288w", "/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/739ea/lecture.png 473w"],
              "sizes": "(max-width: 473px) 100vw, 473px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <hr></hr>
    <h2>{`300 Live Demo (Own Environment)`}</h2>
    <p>{`Do you want this demo in your own environment? Check the assets below to know how to deliver 300 Demo (custom live demos).`}</p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Requesting your Demo Environment" href="https://ibm-garage-tsa.github.io/cp4i-demohub/cp4i-on-roks/" author="Steps to request your CP4I Demo Environment" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "473px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVElEQVQ4y42TTUhUURTH333v3fmesRnHcZSZnLFBzI+yMc0ca8ZMF40I9oGBUVPhTlu1S4I0XASRlRSU7hSxRYgGtUmCgqhFy9wGBW5yVVHR4tdz3tQ4OYQPDve+c8/5/8+noigK25EyT4QSR/kmncieHluQQEl0s21xAKGo2bOiMozHoRFw1VAX6kJT9b82Nt3NcN9DTvVlCJT7CwF9/jIa4y243J4C4HDqDgcys1THqtH+6IVJZtHcJFqP0toWx+v1FQK2p7pJ9qTRLbrhaCceuojF0Jd2TXP4JjRfe03L4AjhUMiwV/OkQmCR+taUA8FKdGnP3qVq53zTSzJ1S3Sl39B76zun59domVul/fYM0V0RFBnEVXMBazBlgMpCQFU1GYXBpogNpZOxM2+ZHf3M5LmvXBn6wcjMGgNL79m/8JTqhjqEczfO2CDS24DQHf9pijC7l6y9xOLdj6y+gndzvxi6us7J55/onF8mWt+YD+Bff4fdxdjYOIuLj2mKx03DXCcdSozh/mleTMGxzvv4hidoXnhGzd49OXINKSXeHSVoWq6OXk+A6alHbHw/v8GRRDr7oGv5ujRWnCDmazLHKNFNRaQq96ZhtTpIJNPYrVphyqmDvfT3ZLBJjzm0BrtQpSGmYVX5Pi73LVPrb8v+a5ole6Z7B5h68AF/tCcXteEs1HwtVH8EvbSqYBts0s3Z5CSjx1eoLG3IAZopjl+fYP0L3Lj3xFiGTRGq6gawBd/OepzBcNHt8bnCWKVzi76jo41U6lDxLmvGCAmxvf0uJr8Bo31qf27UgHwAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lab",
              "title": "lab",
              "src": "/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/739ea/lab.png",
              "srcSet": ["/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/7fc1e/lab.png 288w", "/cp4i-demohub/static/3f2d5443e324f2ebef55db806cd884b1/739ea/lab.png 473w"],
              "sizes": "(max-width: 473px) 100vw, 473px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Preparing your Environment" href="/salesdemos/carrepair-new/prepare" author="Prerequisites and steps to configure your Demo Environment" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "473px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAADH0lEQVQozx3RyU8TcRQH8Dl58OTBqyf/AmMkccW44lIhdU1ErUZERRSDC8SwKCirC6IVF4JgFdFaLbSVUipQ6NCNdijMr3TKYIdOp51pZ7oNndZ9YvK9vMMn7+V9oSAVFgQhlUwzDOvxYE6n24stBIJ0KEQnk7xSqW5rezyD2F1Tkw47PKg3DGj01VX1kn0Fp08XQw5AxBPJbCZLUQwAGBkMB0h6gaDEMRJhoxG2paXNOKzHvLMz0w7LpEnTr37Y3CrdX3CqUAbdrGsfGrH8/fM7Hk9RYXaRpIlASPQ0HWWYKM+nbTZXR0eHD5t1uayIywpQl8tpVSjelpVdh86WVHarx+OJVDothGguEGREGaQYUUYiHBtNLPGZD31KrbZ/HkMX5kGQ/O7HZ6y6N6OaXsgyjX8ygTHH3I+sEE/wDBMLh6MMHRGx+AUxyWSajcZ6ehRzAKFDBAZcvdXH7e+ruyqPQWNTQG32PFHCJMVkMxkulmSjcVHS/32KFzguIW4Wj4TNJi7GmjUKzd2j/vEX/Q0yqFLe1P11uqV3okfnyAppnhdisRRDsywbD4WYEePImRMnpQePKBQ9qNNEEah7fEB5bTcJvwHaZuha1eWyW+0tH+Hq16OIx/8zm0kklrLZX243Wl5+Iydn/cWSyzqdFvciOGKYsw+RpN+qfjr1+UEA0UKyS/l5u6Sld148HwY1r4YEISOkM887OnO3bN+xc299fSMMTzjgIcQ2iqOTwDE87wNut9P0Tf9MLoeOF+3bsGbz1vziLjPRqUM0msHiovN5eyQlpVdUKpVOr5oYH8W8qA9DcR8Q4wHuAEkC1G00GqAD+dIVy1ZWNnbq4ekL585v3rittrbObrPgmM+L2UtrpU9fNosNB4j5MLXo86LUojcIvvhxwHERKHdj3v3W9rq6xk0bcgukhx7JW80OXfdAU5+h4UKVZNW65cUVh+Vd9wYHtcMGvVhVZmmRJ5SEU8UyAajr9bvCQlnhCZnircIDZo32D1ebjl1pOHryRm5O3mrJ2bVFFZKbdy7aLbbamtt9ve8ScYrGx0LwXYHz/QP9YDGX92PrGQAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "cookbook",
              "title": "cookbook",
              "src": "/cp4i-demohub/static/e5f6ce33cbbb51880de510f6b9a298d7/739ea/cookbook.png",
              "srcSet": ["/cp4i-demohub/static/e5f6ce33cbbb51880de510f6b9a298d7/7fc1e/cookbook.png 288w", "/cp4i-demohub/static/e5f6ce33cbbb51880de510f6b9a298d7/739ea/cookbook.png 473w"],
              "sizes": "(max-width: 473px) 100vw, 473px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="300 Demo Script" href="/salesdemos/carrepair-new/300-demoscript" author="How to deliver the Demo" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "473px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.888888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZUlEQVQoz2NI3n8PE6Xsv5d06FHsvvs+E9bFHXiYePBRyoH7mMoYUPj77qYA0cH7ifvuxk5YmTNxWWLNxOyJy2O7F8fvvJFy8EHyvjs4NIO0PYjd/zhh3/2AJYcnzVlx/9qVu7duf3jxfMHi1d6zd6cdBtu/7y6G5n13Uw8/ilp7NimrML5vofOkzRPmrTp1/OSVazfevX+3aNVmx7YlEcuOxGy6mIzkfoTmtKNPXNqXtZdnVq3Zat+7obF7xvH9h/btOXjm2Mmu/lkuXStDF+wLmLUjcvUpuH6Y5gP3o1ed9Ji61XDFpYhNl4rnrPJpnOPdvtS3ZT4QebcuDJy9M2junqC5u4H6o9adAfv/LkPy3jsgr269EjR7p/+cXRLlC+IW7JrTXtpRmFLX0Rm6YG/gwgPBC/YBtQXNA2kOmrsLSCZsv5Zy4B5DyuHHQGtDgBLz9gTM2KYrr29XPLG9KHmnC3tdZbHfwiPBc3YGz98LRIHTtwbN2QVkAJVFrDyecvgRQ8zK49HLjzhEFwfP3enetTItLDhjzqrizNRGS4W6qmLvBYftQ3M8a6YHTN9qH1noN2FN4Mxt9jGlAVM2xm2+yGDtFmPrn2bhFGnpFG7iHBPsG+zuEeZlbOVnaBpnaWoRUmBu5W9m5W/pFmPpEm3hHAlElq7RFi7Rdv5pDMZ6TkCkr2yur2hqoGSmp2yhp2Smr2ppqG5loGJpoGppoGZlpG1vrOdsoGKurwRSY6BioQ9Uo2TGYKBqoQ9SYW2gbg0kDdWswAikDcgA6gTpV7UEq7ECq7GCIKAsg4mmLRAZ40Z4ZAFW8XWeQcvFnAAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "lecture",
              "title": "lecture",
              "src": "/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/739ea/lecture.png",
              "srcSet": ["/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/7fc1e/lecture.png 288w", "/cp4i-demohub/static/54207649d0d07826b9bac9578a8f7129/739ea/lecture.png 473w"],
              "sizes": "(max-width: 473px) 100vw, 473px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      